import React from 'react';
import { Image } from 'antd';
import logo from '../Assets/logo.png';
import bgMedia from '../Assets/bgMedia.png'

const SuspenseLoader = () => {
    return (
        <div style={{ height: '100vh', display: 'grid', placeItems: 'center', background:`url(${bgMedia})` , backgroundRepeat:'no-repeat', backgroundPosition:'center', backgroundSize:'cover'}}>
            <div className='text-center'>
                <Image preview={false} src={logo} height={100} width={250} />
                <h2 className='mt-4' style={{ textAlign: 'center' }}>Please wait...!</h2>
            </div>
        </div>
    )
}

export default SuspenseLoader